import { Data } from '@aytm/app/insights/dashboard/models/types.ClientDTO'
import { InsightsDashboardPoolState } from '@aytm/app/insights/dashboard/duckness/ducks/types'
import {
  deleteFiltersValue,
  updateFilterTags,
  filtersHasValue,
  dataHasValue
} from '@aytm/app/insights/dashboard/lib/filters'

import { updatePanelFilters, getPanelFilters } from './filters'

import { updateCurrentData } from './requests'
import { UpdateOptions } from './request'
import { setInImmutably } from './objects'

export type UpdateTagsPayload = { action?: string; uid: string; tags: string[]; deleted?: string }

export const updateTags = (
  state: InsightsDashboardPoolState,
  { uid, tags, deleted }: UpdateTagsPayload
): InsightsDashboardPoolState => {
  let resultState = state
  // Get state data
  const data = state?.currentData?.data || {}
  // Update tags in current data
  const newData = setInImmutably(data, [uid, 'attributes', 'subjectTags', 'value'], tags) as Data
  // Get state filter options
  const filterOptions = state?.currentData?.filterOptions || {}
  // Process filter options
  const newFilterOptions = updateFilterTags(filterOptions, tags)
  // Update filter options and current filters
  resultState = updateCurrentData(resultState, { data: newData, filterOptions: newFilterOptions })
  // Process filters
  if (deleted) {
    const filters = getPanelFilters(resultState)
    if (filtersHasValue(filters, 'variable:Tag', deleted) && !dataHasValue(newData, 'tags', deleted)) {
      // If filters has last deleted tag remove it from filters
      const newFilters = deleteFiltersValue(filters, 'variable:Tag', deleted)
      // Update model and current filters
      resultState = updatePanelFilters(resultState, newFilters)
    }
  }
  return resultState
}

export const getTagsUpdate = (
  state: InsightsDashboardPoolState,
  { action, uid, tags }: UpdateTagsPayload
): UpdateOptions => {
  const subjects = state?.currentData?.subjects || {}
  const subjectUid = subjects[uid]?.nativeUid || ''
  return {
    type: 'tags',
    action: action,
    data: {
      subjectUid,
      tags: tags
    }
  }
}

export const tagsFiltersChanged = (state: InsightsDashboardPoolState, { deleted }: UpdateTagsPayload): boolean => {
  if (deleted) {
    const filters = getPanelFilters(state)
    return filtersHasValue(filters, 'variable:Tag', deleted)
  }
  return false
}
